import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { MenuItem } from "@/types/menu.type";
import SidebarComponent from "./SidebarComponent.vue";
import securityService from "@/service/security.service";
import { AppRole, AppType } from "@/types/app.type";
import { onMounted, reactive } from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const accionaUser = securityService.hasRole(AppRole.ACCIONA);

const items: MenuItem[] = reactive([
  {
    icon: "el-icon el-icon-home fas",
    index: "/support",
    title: "menu.home",
    disabled: false,
  },
  {
    icon: "el-icon el-icon-eye fas",
    index: "/support/samplingPoints",
    title: "menu.samplingPoints",
    disabled: false,
  },
  {
    icon: "el-icon el-icon-image fas",
    index: "/support/ia",
    title: "menu.images",
    disabled: accionaUser ? true : false,
  },
  {
    icon: "el-icon el-icon-bell fas",
    index: "/support/alerts",
    title: "menu.alerts",
    disabled: accionaUser ? true : false,
  },
  {
    icon: "el-icon el-icon-satellite-dish fas",
    index: "/support/satelite",
    title: "menu.satellite",
    disabled: false,
  },
  // {
  //   icon: "el-icon el-icon-info fas",
  //   index: "/support/support",
  //   title: "menu.support",
  //   disabled: true,
  // },
  {
    icon: "el-icon el-icon-file-export fas",
    index: "/support/report",
    title: "menu.report",
    disabled: accionaUser ? true : false,
  },
  {
    icon: "el-icon el-icon-check fas",
    index: "/support/validation",
    title: "menu.validate",
    disabled: false,
    // subs: [
    // {
    //   icon: "el-icon el-icon-upload fas",
    //   index: "/support/upload",
    //   title: "menu.uploaderData",
    //   disabled: false,
    // },
    // {
    //   icon: "",
    //   index: "/support/validateData",
    //   title: "menu.validateData",
    //   disabled: false,
    // },
    // {
    //   icon: "",
    //   index: "/support/validation",
    //   title: "Prueba",
    //   disabled: false,
    // },
    // ],
  },
]);

onMounted(async () => {
  const canAdmin = securityService.canAccessToApp(AppType.ADMIN);
  const canSupport = securityService.canAccessToApp(AppType.SUPPORT);
  const canStations = securityService.canAccessToApp(AppType.STATIONS);
  if (canSupport && !canStations && !canAdmin) {
    items.shift();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SidebarComponent, { items: _unref(items) }, null, 8, ["items"]))
}
}

})